import { render, staticRenderFns } from "./OpenCustomer.vue?vue&type=template&id=c3519918&"
import script from "./OpenCustomer.vue?vue&type=script&lang=js&"
export * from "./OpenCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports